export default __webpack_public_path__ + "static/media/lit.a503b51d.jpg";